import * as S from '../styles';

const ShuttleInfo = () => {
  return (
    <S.Wrapper isConnect>
      <S.Title type='page'>셔틀 탑승 안내</S.Title>
      <S.Section type='paragraph'>
        <S.Section type='text'>
          <S.Text type='main'>
            제주국제공항 도착 5번 게이트 앞
            <br />
            <br />
            ① 5번 게이트 앞 횡단보도를 건너주세요. ② 횡단보도를 건넌 후
            <br />
            오른쪽 방면 길을 따라 쭉 직진 해주세요.
            <S.Text type='highlight'> (약 110M 이동)</S.Text>
            <br />
            <br />
            렌트카하우스 앞 4구역 12번에서 패밀리렌트카 셔틀 탑승
          </S.Text>
        </S.Section>
      </S.Section>
    </S.Wrapper>
  );
};

export default ShuttleInfo;
